import { Radar, Satellite, Wind, Gauge, LineChart, type LucideIcon } from 'lucide-react'
import { config } from '@/config'

export interface ProductDef {
  id: string
  title: string
  subtitle: string
  icon: LucideIcon
  accent: string
  feedUrl: string
  /** Env var Andrew points at the real feed (shown in the "configure" hint). */
  envVar: string
}

/** The Triple-A product set surfaced as entry tiles over the existing R2 feeds. */
export const PRODUCTS: ProductDef[] = [
  {
    id: 'radar',
    title: 'Radar',
    subtitle: 'Live precipitation',
    icon: Radar,
    accent: 'var(--status-info)',
    feedUrl: config.r2.feeds.radar,
    envVar: 'VITE_FEED_RADAR',
  },
  {
    id: 'floaters',
    title: 'Satellite',
    subtitle: 'Floaters & IR',
    icon: Satellite,
    accent: 'var(--accent)',
    feedUrl: config.r2.feeds.floaters,
    envVar: 'VITE_FEED_FLOATERS',
  },
  {
    id: 'cyclolab',
    title: 'CycloLab',
    subtitle: 'Cyclone analysis',
    icon: Wind,
    accent: 'var(--status-tropics)',
    feedUrl: config.r2.feeds.cyclolab,
    envVar: 'VITE_FEED_CYCLOLAB',
  },
  {
    id: 'meso',
    title: 'Mesoanalysis',
    subtitle: 'SPC surface & upper',
    icon: Gauge,
    accent: 'var(--status-watch)',
    feedUrl: config.r2.feeds.meso,
    envVar: 'VITE_FEED_MESO',
  },
  {
    id: 'models',
    title: 'Models',
    subtitle: 'GFS · ECMWF · HRRR',
    icon: LineChart,
    accent: 'var(--status-quiet)',
    feedUrl: config.r2.feeds.models,
    envVar: 'VITE_FEED_MODELS',
  },
]

export const productById = (id: string | undefined) => PRODUCTS.find((p) => p.id === id)
